angular.module("AccountingBoxApp").config(function($stateProvider) {
  $stateProvider
    .state("app.bookkeeper", {
      abstract: true,
      templateUrl: "app/bookkeeper/bookkeeper.html",
      // template: "<ui-view/>",
      url: "/boekhouder"
    })
    /*  .state('app.company.contacts.edit', {
        url: '/:id/bewerk',
        templateUrl: 'app/contacts/edit/edit.html',
        controller: 'ContactEditCtrl',
        controllerAs: 'ce'
      })*/
    /*    .state('app.company.contacts.list', {
        url: '',
        templateUrl: 'app/contacts/list/list.html',
        controller: 'ContactsListCtrl',
         controllerAs: 'cl'
      }).*/ .state(
      "app.bookkeeper.companies",
      {
        url: "/bedrijven",
        templateUrl: "app/bookkeeper/companies/companies.html",
        controller: "BookkeeperCompaniesCtrl",
        controllerAs: "bc"
      }
    )
    .state("app.bookkeeper.usageOverview", {
      url: "/bedrijven/verbruik",
      templateUrl: "app/bookkeeper/companies/usageOverview.html",
      controller: "BookkeeperUsageOverviewCtrl",
      controllerAs: "bc"
    })

    .state("app.company.settings", {
      url: "/settings",
      templateUrl: "app/bookkeeper/companies/edit/edit.html",
      controller: "CompaniesEditCtrl",
      controllerAs: "ce"
    })
  ;
});
